export const assert = (options: Record<string, unknown>, requiredKeys: string[]) => {
  requiredKeys.forEach((key) => {
    if (!options[key]) {
      throw new TypeError(`Required "${key}" not defined`);
    }
  });
};
